import { render, staticRenderFns } from "./sendTextOrder.vue?vue&type=template&id=50a8fc40&scoped=true&"
import script from "./sendTextOrder.vue?vue&type=script&lang=js&"
export * from "./sendTextOrder.vue?vue&type=script&lang=js&"
import style0 from "./sendTextOrder.vue?vue&type=style&index=0&id=50a8fc40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a8fc40",
  null
  
)

export default component.exports